<!-- Add the focus-radio class below for adding focus on the radio button -->
<input type="text" class="custom-radio-btn-input custom-hidden-input" [disabled]="disabled"
  (keydown.enter)="onChange($event)" (keydown.space)="onChange($event)">

<div class="custom-radio-btn flex-start-center">
  <label *ngIf="position === 'start'" class="m-0 pointer {{styleClassLabel}}"
    [ngClass]="{'pointer': !disabled, 'not-allowed': disabled}" [for]="btnId || value">
    {{label}}
  </label>

  <p-radioButton [inputId]="btnId || value" [name]="name" [value]="value" [ngClass]="{'not-allowed': disabled}"
    [disabled]="disabled" (onClick)="onChange($event)" [(ngModel)]="selectedValue">
  </p-radioButton>

  <img [src]="imgIcon" class="imgIcon" [ngClass]="imgIconClass" *ngIf="imgIcon">

  <label *ngIf="position === 'end'" class="m-0 pointer {{styleClassLabel}}" [ngStyle]="labelColor ? {'color': labelColor} : null"
    [ngClass]="{'pointer': !disabled, 'not-allowed': disabled}" [for]="btnId || value">
    {{label}}
  </label>
</div>
